import { render, staticRenderFns } from "./processMaterialList.vue?vue&type=template&id=5b3e6161&scoped=true&"
import script from "./processMaterialList.vue?vue&type=script&lang=js&"
export * from "./processMaterialList.vue?vue&type=script&lang=js&"
import style0 from "./processMaterialList.vue?vue&type=style&index=0&id=5b3e6161&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3e6161",
  null
  
)

export default component.exports